<template>
  <div class="Layout">
    <header>
      <div class="name">
        <div class="shop_name">{{shop_name}}</div>
        <div class="user_name">{{user_name}}</div>
      </div>
      <div class="order_last">
        <!-- <div>上笔订单：0001</div>
        <div>12900.00元</div>
        <div class>买家名字</div> -->
        <div class="date">
          {{time}}
        </div>
        <div class="top_personal" style="margin-left:0.3rem;" @touchstart="toPersonal()">
          <img src="./../../assets/img/tabBar/tab-personal-w.png" alt="">
        </div>
      </div>
    </header>
    <section class="layout_section">
      <div class="layout_left">
        <div
          :class="activeTab==item.path?'menu_item active':'menu_item'"
          v-for="(item,index) in tabbarList"
          :key="index"
          @touchstart="changeMenu(item)"
        >
          <div>
            <div class="icon">
              <img v-if="activeTab==item.path" :src="item.icon.active" alt />
              <img v-else :src="item.icon.inactive" alt />
            </div>
            <div class="name">{{item.title}}</div>
          </div>
        </div>
      </div>
      <div class="layout_right">
        <navigation>
            <router-view></router-view>
        </navigation>
        <!-- <keep-alive>
            <router-view></router-view>
        </keep-alive> -->
      </div>
    </section>
  </div>
</template>

<script>
import Cookies from "@/utils/Cookies";
import {longtimestampToTime} from '@/utils/timestamp'
export default {
  name: "Layout",
  data() {
    return {
      activeTab: "/open",
      tabbarList: [
        {
          title: "收银",
          path: "/open",
          icon: {
            active: require("@/assets/img/tabBar/tab-open-h.png"),
            inactive: require("@/assets/img/tabBar/tab-open-m.png")
          }
        },
        {
          title: "库存管理",
          path: "/stock",
          icon: {
            active: require("@/assets/img/tabBar/tab-stock-h.png"),
            inactive: require("@/assets/img/tabBar/tab-stock-m.png")
          }
        },
        {
          title: "货主管理",
          path: "/owner",
          icon: {
            active: require("@/assets/img/tabBar/tab-owner-h.png"),
            inactive: require("@/assets/img/tabBar/tab-owner-m.png")
          }
        },
        {
          title: "买家管理",
          path: "/buyer",
          icon: {
            active: require("@/assets/img/tabBar/tab-buyer-h.png"),
            inactive: require("@/assets/img/tabBar/tab-buyer-m.png")
          }
        },
        {
          title: "订单管理",
          path: "/order",
          icon: {
            active: require("@/assets/img/tabBar/tab-order-h.png"),
            inactive: require("@/assets/img/tabBar/tab-order-m.png")
          }
        },
        {
          title: "报表统计",
          path: "/data",
          icon: {
            active: require("@/assets/img/tabBar/tab-data-h.png"),
            inactive: require("@/assets/img/tabBar/tab-data-m.png")
          }
        },
      ],
      shop_name: JSON.parse(Cookies.get("shopInfo")).shop_name || "",
      user_name:JSON.parse(Cookies.get("userInfo")).realname || "",
      time:''
    };
  },
  watch: {
    $route(to, from) {
      this.activeTab = to.matched[1].path 
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.activeTab = to.matched[1].path 
    });
  },
  mounted() {
    this.$setLEDText( JSON.parse(Cookies.get("shopInfo")).shop_name )
    setInterval(() => {
      this.time = longtimestampToTime(new Date().getTime())
    }, 1000);
  },
  methods: {
    // 切换菜单
    changeMenu(item) {
      // console.log(11,this.$navigation.getRoutes())
      // this.$navigation.cleanRoutes()
      // console.log(22,this.$navigation.getRoutes())
      this.activeTab = item.path;
      this.$router.push(item.path);
    },

    // 去个人中心
    toPersonal(){
      this.$router.push("/personal");
    },
  }
};
</script>

<style lang="less" scoped>
.Layout {
  position: relative;
  height: 100vh;
  width: 100%;
  header {
    width: 100%;
    height: 0.54rem;
    box-sizing: border-box;
    padding: 0 0.15rem;
    background-color: #31b158;
    color: #fff;
    line-height: 0.54rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .name {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      div {
        margin-right: 0.1rem;
      }
      .user_name{
        margin-top: 0.05rem;
        font-size: 0.2rem;
        vertical-align: baseline;
        margin-left: 0.3rem;
        color: #e1e1e1;
      }
    }
    .order_last {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 0.2rem;
      div {
        margin-left: 0.1rem;
      }
    }
    .top_personal{
      display: flex;
      align-items: center;
      width: 0.54rem;
      height: 0.50rem;
      justify-content: center;
      img{
        height: 0.32rem;
        margin-right: 0.02rem;
      }
    }
  }
  .layout_section {
    width: 100%;
    height: calc(100% - 0.54rem );
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .layout_left {
      height: 100%;
      width: 0.7rem;
      background-color: #303540;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-between;
      .menu_item {
        width: 100%;
        height: 16%;
        display: flex;
        align-items: center;
        justify-content: center;
        &.active {
          background-color: #1f2125;
          color: #fff;
          .name{
            color: #fff;
          }
        }
        & > div {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          .icon {
            width: 0.4rem;
            height: 0.4rem;
            margin-bottom: 0.1rem;
            img {
              width: 0.4rem;
              height: 0.4rem;
            }
          }
          .name {
            width: 100%;
            text-align: center;
            font-size: 0.14rem;
            color: #999;
          }
        }
      }
    }
    .layout_right {
      width: calc(100% - 0.7rem);
      height: 100%;
      overflow-y: auto;
      &>div{
          min-height: 100%;
      }
    }
  }
}
</style>